exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.activity-log-container{display:flex;flex-direction:column;height:100%;margin:0 75px}.activity-log-container .activity-log-body{display:flex;flex-direction:column;position:relative;margin-top:16px;height:100%}.activity-log-container .activity-log-body .activity-log-details{position:relative;display:flex;align-items:center;width:calc(100% - 15px);height:70px}.activity-log-container .activity-log-body .activity-log-details .activity-log-title{font-family:Open Sans,sans-serif;font-style:italic;font-weight:700;width:127px;font-size:24px;color:#4a4a4a}.activity-log-container .activity-log-body .activity-log-details .activity-count{font-family:Open Sans,sans-serif;font-size:14px;color:#9b9b9b;padding-top:9px}.activity-log-container .activity-log-body .activity-log-details .activity-log-search{width:20%;align-items:right;position:absolute;right:0;top:6px}.activity-log-container .activity-log-body .activity-log-details .activity-log-search .download-report{position:absolute;right:340px;top:18px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ManagerDashboard/ActivityLog/ActivityLog.scss
// module id = 1741
// module chunks = 0